import React from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { PersistGate } from 'redux-persist/integration/react'
import store, { persistor } from './store'
import Theme from 'components/template/Theme'
import Layout from 'components/layout'
import history from './history'
import mockServer from './mock'
import appConfig from 'configs/app.config'
import './locales'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import SocketProvider from 'components/route/SocketContext'
import { HelpProvider } from 'contexts/HelpContext'
import { HelpModal } from 'components/shared'

const environment = process.env.NODE_ENV

const queryClient = new QueryClient()

/**
 * Set enableMock(Default false) to true at configs/app.config.js
 * If you wish to enable mock api
 */
if (environment !== 'production' && appConfig.enableMock) {
    mockServer({ environment })
}

function App() {
    return (
        <QueryClientProvider client={queryClient}>
            <Provider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                    <BrowserRouter>
                        <SocketProvider>
                            <HelpProvider>
                                <Theme>
                                    <Layout />
                                </Theme>
                                <HelpModal />
                            </HelpProvider>
                        </SocketProvider>
                    </BrowserRouter>
                </PersistGate>
            </Provider>
        </QueryClientProvider>
    )
}

export default App
